export const reviews = [
  {
    name: 'Astm Ali — Egypt',
    role: 'Ruby on Rails & PHP Developer',
    avatar: '/img/customers/1.jpg',
    text: 'I worked with Noor before, he is a talented front-end developer and amazing person. His code is maintainable and his code smell was amazing, I adore his code and wish to work with him again in the future.',
  },
  {
    name: 'Farhan Majid',
    role: 'Sr Digital Marketing Professional | B2B SaaS',
    avatar: '/img/customers/2.png',
    text: 'I worked with Noor when I was leading marketing at Naxxa Consulting. I was extremely impressed with his knowledge, technical ability and attention to detail. Noor had a calm and collected influence on the team even under deadline pressure and was easy to get along with. He worked on landing pages, website redesign, and improving the UI of the application with an aim to deliver exceptional customer experience and increase conversion rates.',
  },
  {
    name: 'Naqash Malik',
    role: 'Principal Software Engineer at Uforia Infotech',
    avatar: '/img/customers/3.png',
    text: 'It was a great experience working with Noor on a number of projects. Not only does he create highly creative and purposeful web and print designs, his background in Front End Development and graphic design is a big plus. He is an articulate professional who communicates well in a team as well as individually. I would highly recommend Noor based on his experience, knowledge, and personal skills.',
  },
  {
    name: 'Usman Javed',
    role: 'Web Developer at Face44',
    avatar: '/img/customers/4.png',
    text: "I've done some very intense and tricky projects with Noor over the years and I'm truly blessed to have had him working with us. His work ethic is amazing, he's always on time and budget, always goes the extra mile, and constantly over delivers. His communication is always on point and he's always there for support and advice.",
  },
  {
    name: 'Muhammad Abdullah',
    role: 'Sr. Full Stack Developer at Truemeridian Pvt Ltd',
    avatar: '/img/customers/thumbnail.png',
    text: 'Noor is a very talented front-end developer and also a very nice person. He has profound knowledge of Bootstrap, CSS, and Photoshop. He takes initiative and knows what he is doing. Also a very good friend and a very nice colleague.',
  },
  {
    name: 'Dauran Raza',
    role: 'Sr Quality Assurance Analyst at ZeptoSystems',
    avatar: '/img/customers/thumbnail.png',
    text: 'Noor is a talented Front End Developer and graphics designer, great to work with. He has ingenious web skills with an eye for detail, is very innovative, and always looking for fresh ideas that advance his knowledge to exceed client expectations. A fun person to work with, always helpful and insightful.',
  },
]
